import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import pl from './locales/pl.json';
import rus from './locales/rus.json';
import ua from './locales/ua.json';

const resources = {
  pl: {
    translation: pl
  },
  rus: {
    translation: rus
  },
  ua: {
    translation: ua
  },
  en: {
    translation: en
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pl', // Polish as main language
    lng: 'pl', // Default language
    
    detection: {
      order: ['localStorage', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'] // Only use localStorage, no cookies (GDPR compliance)
    },

    interpolation: {
      escapeValue: false // React already does escaping
    },

    react: {
      useSuspense: false
    }
  });

export default i18n;